export function MultilanguageStringParse (str: string, lang?: string): string {
  const parts = str.split(' / ');
  if (lang === 'ky' || lang === 'kg') return parts[0];
  if (lang === 'ru') return parts[1] || parts[0];
  if (lang === 'en') return parts[2] || parts[0];
  return str;
}
